export const toIsoFromDateTimeParts = (date: string, time: string) => {
  const hasSlash = date.includes("/");
  let yyyy = "", mm = "", dd = "";

  if (hasSlash) {
    const [d, m, y] = date.split("/");
    dd = d; mm = m; yyyy = y;
  } else {
    const [y, m, d] = date.split("-");
    dd = d; mm = m; yyyy = y;
  }

  return `${yyyy}-${mm}-${dd}T${time}:00`;
};
